// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-me__section {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #939393;
  border-radius: 5px 5px 0 0;
  border: 1px solid black;
}

.projects-section {
  border-radius: 0 0 5px 5px;
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
}

.education__section {
  border: 1px solid black;
  border-radius: 5px;
}

/* TODO: this should be exported to be global page width*/

.about-me__page-wrapper {
  width: 100%;
}
.about-me__page-width {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 3px solid black; */
}

.about-me__img {
  align-self: center;
  border-radius: 100%;
  width: 250px;
  height: 250px;
  object-fit: cover;
  border-radius: 50%;
  margin-top: 10px;

  margin: 10px;
}

.about-me-profile-card-wrapper {
  display: flex;
  flex-direction: column;
}

.about-me__contact-card {
  margin: 25px 50px 25px 15px;
}

.about-me__bio {
  /* margin: 0 50px 0 0; */
  padding-right: 25px;
}

.skills {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 15px 0;
  border: solid 3px #eee;
  width: 100%;
}

.skills h2 {
}

.about-me-bio {
  width: 95%;
  align-self: center;
  margin: 0 50px 0 0;
}

.skills-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.skill-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  padding: 0;
  margin: 0;
}

.skill {
  color: black;
}

.tech {
  color: #404040;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  margin: 5px;
  border: 1px solid #404040;
  padding: 10px;
  border-radius: 10px;
}

.tech-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tech-tile__name {
  color: #3e3e3e;
}

.education__section__experience-section {
  margin: 10px;
}

.about-me-wrapper {
  display: flex;
  /* flex-direction: column; */
  width: 80%;
  /* align-items: center; */
  align-self: center;
  margin-top: 5px;
}

.download {
  display: flex;
  justify-content: center;
  margin: 10px;
}

.button {
  background: black;
  border: none;
  border-radius: 5px;
  color: white;
  width: 250px;
  height: 40px;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.about-me-goals {
  text-decoration-style: wavy;
}

.goal {
  list-style: disc;
}

.tech img {
  width: 125px;
  height: 125px;
  object-fit: contain;
}
.section_title {
  margin: 0 0 25px 25px;
}

.projects-section,
.education__section,
.about-me__section {
  max-width: 1024px;
  width: 100%;
  background: white;
  padding: 50px;
}

.projects-section,
.education__section {
  display: flex;
  /* overflow: hidden; */
  flex-direction: column;
}

/* .projects-section {
  margin: 50px 0;
} */

/* .education__section {
  max-height: 450px;
} */

.experience-section__cards {
  max-height: 450px;
  overflow-y: scroll;
  height: 100%;
}

.tech-stack__section {
  margin: 50px 0;
  width: 100%;
}

.tech-stack__section-wrapper {
  position: relative;
  overflow-x: scroll;
  box-shadow: inset 0px 0px 10px rgba(100, 100, 100, 0.5);
  padding: 25px 0;
}

.tech-stack__overlay {
  background-color: #3e3e3e;
  position: absolute;
  width: 1950px;
  height: 100%;
  opacity: 0.3;
  top: 0;
}

.project-section__thumbnail-carosel,
.education__section__thumbnail-carosel {
  display: flex;
  overflow-x: scroll;
  /* max-width: 925px; */
}

.education__section__experience-experience-section {
  flex-direction: column;
  overflow: hidden;
}

.education__section__experience-experience-section--expanded {
  flex-direction: column;
  overflow: hidden;
}

/* .thumb-nail__wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
} */

.thumbnail-matrix {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1250px) {
  .projects-section2 .education__section,
  .about-me__section {
    padding: 50px;
  }
}

@media (max-width: 1150px) {
  .projects-section,
  .education__section,
  .about-me__section {
    padding: 50px 15px;
  }
}

@media (max-width: 1025px) {
  .projects-section,
  .education__section,
  .about-me__section {
    padding: 50px 0;
  }
}

@media (max-width: 750px) {
  .about-me__section {
    display: flex;
    flex-direction: column;
  }

  .about-me__contact-card {
    margin: 0;
  }

  .about-me__bio {
    padding: 50px;
  }

  .experience-card {
    flex-direction: column;
    align-items: center;
  }

  .experience-card__img {
    max-width: none;
  }
}

@media (max-width: 600px) {
  .about-me-wrapper {
    flex-direction: column;
  }
}

@media (max-width: 450px) {
  .about-me-img {
    width: 100%;
  }

  .about-me-wrapper {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/about-me/about-me.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,yDAAyD;;AAEzD;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,MAAM;AACR;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".about-me__section {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #939393;\n  border-radius: 5px 5px 0 0;\n  border: 1px solid black;\n}\n\n.projects-section {\n  border-radius: 0 0 5px 5px;\n  border-bottom: 1px solid black;\n  border-left: 1px solid black;\n  border-right: 1px solid black;\n}\n\n.education__section {\n  border: 1px solid black;\n  border-radius: 5px;\n}\n\n/* TODO: this should be exported to be global page width*/\n\n.about-me__page-wrapper {\n  width: 100%;\n}\n.about-me__page-width {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* border: 3px solid black; */\n}\n\n.about-me__img {\n  align-self: center;\n  border-radius: 100%;\n  width: 250px;\n  height: 250px;\n  object-fit: cover;\n  border-radius: 50%;\n  margin-top: 10px;\n\n  margin: 10px;\n}\n\n.about-me-profile-card-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.about-me__contact-card {\n  margin: 25px 50px 25px 15px;\n}\n\n.about-me__bio {\n  /* margin: 0 50px 0 0; */\n  padding-right: 25px;\n}\n\n.skills {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 15px 0;\n  border: solid 3px #eee;\n  width: 100%;\n}\n\n.skills h2 {\n}\n\n.about-me-bio {\n  width: 95%;\n  align-self: center;\n  margin: 0 50px 0 0;\n}\n\n.skills-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.skill-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\n\n.skill {\n  color: black;\n}\n\n.tech {\n  color: #404040;\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: center;\n  align-items: center;\n  margin: 5px;\n  border: 1px solid #404040;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.tech-tile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tech-tile__name {\n  color: #3e3e3e;\n}\n\n.education__section__experience-section {\n  margin: 10px;\n}\n\n.about-me-wrapper {\n  display: flex;\n  /* flex-direction: column; */\n  width: 80%;\n  /* align-items: center; */\n  align-self: center;\n  margin-top: 5px;\n}\n\n.download {\n  display: flex;\n  justify-content: center;\n  margin: 10px;\n}\n\n.button {\n  background: black;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  width: 250px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n}\n\n.about-me-goals {\n  text-decoration-style: wavy;\n}\n\n.goal {\n  list-style: disc;\n}\n\n.tech img {\n  width: 125px;\n  height: 125px;\n  object-fit: contain;\n}\n.section_title {\n  margin: 0 0 25px 25px;\n}\n\n.projects-section,\n.education__section,\n.about-me__section {\n  max-width: 1024px;\n  width: 100%;\n  background: white;\n  padding: 50px;\n}\n\n.projects-section,\n.education__section {\n  display: flex;\n  /* overflow: hidden; */\n  flex-direction: column;\n}\n\n/* .projects-section {\n  margin: 50px 0;\n} */\n\n/* .education__section {\n  max-height: 450px;\n} */\n\n.experience-section__cards {\n  max-height: 450px;\n  overflow-y: scroll;\n  height: 100%;\n}\n\n.tech-stack__section {\n  margin: 50px 0;\n  width: 100%;\n}\n\n.tech-stack__section-wrapper {\n  position: relative;\n  overflow-x: scroll;\n  box-shadow: inset 0px 0px 10px rgba(100, 100, 100, 0.5);\n  padding: 25px 0;\n}\n\n.tech-stack__overlay {\n  background-color: #3e3e3e;\n  position: absolute;\n  width: 1950px;\n  height: 100%;\n  opacity: 0.3;\n  top: 0;\n}\n\n.project-section__thumbnail-carosel,\n.education__section__thumbnail-carosel {\n  display: flex;\n  overflow-x: scroll;\n  /* max-width: 925px; */\n}\n\n.education__section__experience-experience-section {\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.education__section__experience-experience-section--expanded {\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* .thumb-nail__wrapper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n} */\n\n.thumbnail-matrix {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 1250px) {\n  .projects-section2 .education__section,\n  .about-me__section {\n    padding: 50px;\n  }\n}\n\n@media (max-width: 1150px) {\n  .projects-section,\n  .education__section,\n  .about-me__section {\n    padding: 50px 15px;\n  }\n}\n\n@media (max-width: 1025px) {\n  .projects-section,\n  .education__section,\n  .about-me__section {\n    padding: 50px 0;\n  }\n}\n\n@media (max-width: 750px) {\n  .about-me__section {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .about-me__contact-card {\n    margin: 0;\n  }\n\n  .about-me__bio {\n    padding: 50px;\n  }\n\n  .experience-card {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .experience-card__img {\n    max-width: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .about-me-wrapper {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 450px) {\n  .about-me-img {\n    width: 100%;\n  }\n\n  .about-me-wrapper {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
